import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom'
import { v4 as uuid } from "uuid";
import axiosinstances from '../../Helper/useAxios'

export default function BillPaymentRouting() {
    const navigate = useNavigate();
    const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
    const newId = id
    const unique_id = uuid();
    const [axiosInstance] = axiosinstances()
    const [profileDetails,setProfileDetails] = useState()
    const profileId = useParams()
    const [tcpUrls, setTcpUrls] = useState({})
    const [isupdateRouting, setIsupdateRouting] = useState(false)
    const [dmtDetails, setDmtDetails]= useState({
        id:profileId?.id,
        name: profileDetails?.businessInfo?.name !== undefined ? profileDetails?.businessInfo?.name : '',
        async:false,
        encrypted:false,
        clientId:'',
        orderStatusCallback:'',
        defaultSupplierId:'',
        tpsAccEnabled: false,
        tpsAccUrl:null
    })
    //console.log('dmtDetails', dmtDetails)
    const token=JSON.parse(sessionStorage.getItem('token'))
    const  getprofileserviicesresponse = (data) => {
		return  axiosInstance
		.get(`/api/v1/retailer/get/${profileId.id}`,{ headers: {"Authorization" : `Bearer ${token}`,"client-id":newId,"role":"ROLE_RETAILER_FINXPAY"}})
		.then(response => {
			if (response) {
				//console.log('res', response)
				const { data } = response
				setProfileDetails(data)
                setDmtDetails((prev)=>({
                    ...prev,
                   name: data?.businessInfo?.name !== undefined ? data?.businessInfo?.name : ''
                }))
			}
			return false
		})
	   .catch((err) => {
		 //console.log(err);
	   });
		
	}

    const  getDmtroutingresponse = (data) => {
		return  axiosInstance
		.get(`/api/v1/billpay/client-routing/admin/get/${profileId.id}`,{ headers: {"Authorization" : `Bearer ${token}`,"client-id":newId,"role":"ROLE_RETAILER_FINXPAY"}})
		.then(response => {
        
			if (response.status == 200) {
				//console.log('res routing', response)
                setIsupdateRouting(true) 
				const { data } = response
				//setProfileDetails(data)
                setDmtDetails((prev)=>({
                    ...prev,
                  ...data
                }))
			} else if(response.status == 500) {
                setIsupdateRouting(false)  
            }
          
			return false
		})
	   .catch((err) => {
		 //console.log(err);
	   });
		
	}
    const profileDetailsPage = () =>{
        navigate(`/profile/${profileId?.id}`)
      }
	useEffect(()=>{
    if(id!== undefined ){
        getprofileserviicesresponse()
        getDmtroutingresponse()
    }
	
	},[id])
    const handleChange =(e) =>{
     let {value, name} = e.target
     //console.log('name', name)
     if(value == 'true'){
        value = true
     } else if(value==='false'){
        value = false
     }

    //  if(name == "tpsAccEnabled" && !dmtDetails.tpsAccEnabled){
    //     setDmtDetails((prev)=>(
    //         {
    //             ...prev, tpsAccEnabled:{}
    //         }
    //      ))  
    //  }
     setDmtDetails((prev)=>(
        {
            ...prev, [name]:value
        }
     ))
    } 
    const tcpChange = (e) =>{
        const {value, name} = e.target
        
        const urlValue = dmtDetails.tpsAccUrl !== null ? dmtDetails.tpsAccUrl : {}
            urlValue[name] = value
        setDmtDetails((prev)=>({
            ...prev,
            tpsAccUrl:urlValue
        }))
    }
    //console.log('dmtDetails', dmtDetails) 
    const date = new Date()
    const createUser = async (roId) => {
		const url = isupdateRouting ?  `/api/v1/billpay/client-routing/admin/update` : `/api/v1/billpay/client-routing/admin/create`
        const response = await axiosInstance
        .post(url,
        {
        ...dmtDetails
        },{
                headers: {
                  Authorization: `Bearer ${token}`,
                  "client-id": id,
                   role: "ROLE_RETAILER_FINXPAY",
                } })
       .then((res) => {
        //console.log('created res-->', res)
        if(res.status == 200){
        profileDetailsPage()
        }
        
         
       })
       .catch((err) => {
         //console.log(err);
         
       });
    
        if (response) {
          const result = response.data.orders;
          
          if (result) {
          }
    
          return response.data;
        }
        return false;
      }; 
  const handleSubmit =(e)=>{
    e.preventDefault()
    createUser()
  }
    return (
    <div class="mid-contant">
	<div class="container">		
		<div class="row">
			<div class="col-12">
				<div class="head">
					<h2>Bill Payment Routing <span style={{fontSize:18, fontWeight:400}}>(client's name/id - {profileDetails?.businessInfo?.name !== undefined ? profileDetails?.businessInfo?.name : ''} - {profileId?.id})</span> </h2> 
				</div>
			</div>
			
			<div class="col-12">
				<div class="registerbox">
					<div class="row mb-3">
						<div class="col-12 col-lg-7">
							<form onSubmit={handleSubmit}  >
							<div class="row">								
                           
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id='ocall'  placeholder="Enter Order status Call" name='orderStatusCallback' onChange={handleChange} value={dmtDetails.orderStatusCallback} />
										<label for="ocall">Client Callback URL</label>
										{/* {personalDetails.personalInfo.lname.length > 2 && isLnameCorrect &&	<small style={{color:'red'}} >Enter Valid Last Name</small>} */}
									</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="dsid" placeholder="Enter Default Supplier Id" name='defaultSupplierId' onChange={handleChange} value={dmtDetails.defaultSupplierId} />
										<label for="dsid">Default Supplier Id</label>
					
										{/* {personalDetails.personalInfo.mobile.length > 1 && isMobileCorrect &&	<small style={{color:'red'}} >Enter Valid Mobile Number</small>} */}
									</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="clientId" placeholder="Enter client Id" name='clientId' onChange={handleChange} value={dmtDetails.clientId}  />
										<label for="clientId">ClientId Id</label>
										{/* { personalDetails.personalInfo.email.length > 3 && isEmailCorrect &&	<small style={{color:'red'}} >Enter Valid Email id</small>} */}
									</div>
								</div>
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<select class="form-select"  id="encrypted" name='encrypted' onChange={handleChange} value={dmtDetails.encrypted} >
											<option value="">Select</option>
											<option value={true}>Yes</option>
											<option value={false}>No</option>
										</select>
										<label for="encrypted">Encrypted</label>
									</div>
								</div>
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<select class="form-select"  id="async" name='async' onChange={handleChange} value={dmtDetails.async} >
											<option value="">Select</option>
											<option value={true}>Yes</option>
											<option value={false}>No</option>
										</select>
										<label for="async">Async</label>
									</div>
								</div>						
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<select class="form-select"  id="tpsAccEnabled" name='tpsAccEnabled' onChange={handleChange} value={dmtDetails.tpsAccEnabled} >
											<option value="">Select</option>
											<option value={true}>Yes</option>
											<option value={false}>No</option>
										</select>
										<label for="tpsAccEnabled">3rd Party Accounting Enabled</label>
									</div>
								</div>
								
                                {
                                    dmtDetails.tpsAccEnabled && 
                                    <div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="debit" placeholder="Enter Debit url"  name='debit' onChange={tcpChange} value={dmtDetails?.tpsAccUrl?.debit !== undefined ? dmtDetails?.tpsAccUrl?.debit : ''} />
										<label for="debit">Debit URL</label>
										{/* { personalDetails.personalInfo.email.length > 3 && isEmailCorrect &&	<small style={{color:'red'}} >Enter Valid Email id</small>} */}
									</div>
								</div>
                                }
                                
                                {
                                  dmtDetails.tpsAccEnabled && <div class="col-12 col-md-6">
                                  <div class="form-floating">
                                      <input type="text" class="form-control" id="refund" placeholder="Enter Refund url" name='refund' onChange={tcpChange} value={dmtDetails?.tpsAccUrl?.refund !== undefined ? dmtDetails?.tpsAccUrl?.refund : ''}   />
                                      <label for="refund">Refund URL</label>
                                      {/* { personalDetails.personalInfo.email.length > 3 && isEmailCorrect &&	<small style={{color:'red'}} >Enter Valid Email id</small>} */}
                                  </div>
                              </div>  
                                }

                                {
                                   dmtDetails.tpsAccEnabled &&  
                                   <div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="enquiry" placeholder="Enter Enquiry" name='enquiry' onChange={tcpChange} value={dmtDetails?.tpsAccUrl?.enquiry !== undefined ? dmtDetails?.tpsAccUrl?.enquiry : ''}  />
										<label for="enquiry">Enquiry</label>
										{/* { personalDetails.personalInfo.email.length > 3 && isEmailCorrect &&	<small style={{color:'red'}} >Enter Valid Email id</small>} */}
									</div>
								</div> 
                                }
                                
                                

								<div class="col-12" >
									<button  type="submit" class="btn btn-primary" id="">Proceed</button>
								</div>								
							</div>
							</form>							
						</div>
						
						<div class="col-12 col-lg-5 d-none d-lg-block">
							<div class="rightbanner"><img src={require('../../assests/images/register.png')} alt="Oxigen" class="img-fluid"/></div>
						</div>				
					</div>
				</div>
			</div>
		</div>
	</div>
    </div>
  )
}
